import { ShipmentLoadTransportOrderModel } from '../../models';
import { LoadIdView } from '../../../../models';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import {
  ShipmentLoadTransportOrdersState,
  ShipmentLoadTransportOrdersStateModel,
} from './shipment-load-transport-orders.state';
import {
  ShipmentLoadTransportOrdersInitialState,
  ShipmentLoadTransportOrdersLoad,
} from './shipment-load-transport-orders.actions';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ShipmentLoadTransportOrdersFacade implements LoadDataFacade, SetInitialStateFacade {
  state$: Observable<ShipmentLoadTransportOrdersStateModel> = this.store.select(
    ShipmentLoadTransportOrdersState.getState,
  );
  loaded$: Observable<boolean> = this.store.select(ShipmentLoadTransportOrdersState.getLoaded);
  transportOrders$: Observable<ShipmentLoadTransportOrderModel[]> = this.store.select(
    ShipmentLoadTransportOrdersState.getTransportOrders,
  );

  constructor(private store: Store) {}

  loadAll(params: LoadIdView): void {
    this.store.dispatch(new ShipmentLoadTransportOrdersLoad(params));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentLoadTransportOrdersInitialState());
  }
}
